import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import ListHeader from '../../components/list/ListHeader';
import TableUI from '../../components/list/TableUI';
import FilterPannel from '../../components/filter/FilterPannel';

import HeaderViewList from '../list/HeaderViewList';
import Const from '../../util/Constants';
import SalesOrderAPI from '../../api/SalesOrderAPI';
import KeyValueAPI from '../../api/KeyValueAPI';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import ViewController from '../../controller/ViewController';
import ImportExportAPI from '../../api/ImportExportAPI';

class SalesOrderList extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).sales_order;

    const query = new URLSearchParams(props.location.search);
    const filters = query.get('filters') ? JSON.parse(query.get('filters')) : null;

    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    this.views = ViewController.getViews(Const.SalesOrder);
    this.view = this.views.find(view => view.id === (filters ? 0 : cView.sales_order ? cView.sales_order : 0));
    if (!this.view) {
      this.view = this.views.find(view => view.type === 0);
    }

    this.setList(filters);

    this.data = { sales: [], count: 0 };
    this.state = {
      massUpdate: false, massEmail: false, massSMS: false, massWhatsApp: false,
      inApiCall: true, isFilterOpen: false, popup: ''
    };

    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Add = Util.isAllow(this.model.permission, Const.PermAdd);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);

    /*
    this.list = reactLocalStorage.getObject(Const.ListSales);

    const user = parseInt(reactLocalStorage.getObject(Const.LoggedInUser).user_id);
    this.User = Const.Opt + user + Const.Opt;

    if(filters) this.list.filters = filters;
    else if(!this.list.filters) { this.list.filters = []; }
    if(!this.list.isFilterOpen) { this.list.isFilterOpen = false; }
    if(!this.list.pagination) { this.list.pagination = { currentPage:1, pageCount:1, perPage: 10}; }

    const fieldList = reactLocalStorage.getObject(Const.FieldList);
    if(fieldList && fieldList.sales) { 
      this.list.fields = fieldList.sales; 
    } else {
      this.list.fields = ['start_date', 'model', 'probability', 'responsible_person', 'total'];
    }

    if(!this.list.sorting) {
      this.list.sorting = fieldList && fieldList.sales_sort ? fieldList.sales_sort 
        : { field: 'start_date', order: -1 };
    }
    
    this.state = { inApiCall: true, isFilterOpen: this.list.isFilterOpen };
    
    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);
    */
  }

  componentDidMount() {
    if (this.List) {
      this.loadSales();
    }
  }

  setList = filters => {
    let modelfields = reactLocalStorage.getObject(Const.FieldList);
    let lists = modelfields.sales_order;
    if (!lists) {
      lists = [];
      modelfields = { ...modelfields, sales_order: lists };
    }

    const fields = ["model", "sales_type", "property_type", "project", "room", "property", "probability",
      "responsible_person"];
    this.list = lists.find(list => list.view === this.view.id);

    if (!this.list) {
      this.list = { view: this.view.id };
      modelfields = { ...modelfields, sales_order: [...modelfields.sales_order, this.list] };
    }
    this.list.fields = this.view.fields && this.view.fields.length > 0 && this.view.fields[0] ? this.view.fields
      : this.list.fields ? this.list.fields : fields;
    this.list.filters = filters ? filters : this.list.filters ? this.list.filters : [];

    this.list.pagination = this.list.pagination ? this.list.pagination : {};
    this.list.pagination.currentPage = this.list.pagination.currentPage ? this.list.pagination.currentPage : 1;
    this.list.pagination.pageCount = this.list.pagination.pageCount ? this.list.pagination.currentPage : 1;
    this.list.pagination.perPage = this.list.pagination.perPage ? this.list.pagination.perPage : 10;

    this.list.sorting = this.list.sorting ? this.list.sorting : {};
    this.list.sorting.field = this.view.sortField ? this.view.sortField : 'id';
    this.list.sorting.order = this.view.sortOrder ? this.view.sortOrder : -1;

    if (this.ListRestrict) {
      this.list.fields = this.view && this.view.fields && this.view.fields.length > 0 ? this.view.fields : fields;
    }

    this.list.fields = this.list.fields.filter((field) => {
      if (!field) {
        return false;
      }

      if (field.includes(Const.Opt))
        return (
          this.model.fields[field.split(Const.Opt)[0]] &&
          this.model.fields[field.split(Const.Opt)[0]].visible === Const.True
        );
      else
        return (
          this.model.fields[field] &&
          this.model.fields[field].visible === Const.True
        );
    });

    reactLocalStorage.setObject(Const.FieldList, modelfields);
  };

  saveListFields = fields => {
    let tmpField = reactLocalStorage.getObject(Const.FieldList);
    if (tmpField.sales_order) {
      const tmp = tmpField.sales_order.find((item) => item.view === this.view.id);
      if (tmp) {
        tmp.fields = fields;
      } else {
        tmpField = { ...tmpField, sales_order: [...tmpField.sales_order, { view: this.view.id, fields }] };
      }
    } else {
      tmpField = { ...tmpField, sales_order: [{ view: this.view.id, fields }] };
    }
    reactLocalStorage.setObject(Const.FieldList, tmpField);
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => { });
  };

  saveListSort = sort => {
    let fieldList = reactLocalStorage.getObject(Const.FieldList);
    if (!fieldList) fieldList = {};
    fieldList = { ...fieldList, sales_sort: sort };
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, fieldList, () => { });
  };

  loadSales = () => {
    reactLocalStorage.setObject(Const.ListSales, this.list);
    const mainFilters = ViewController.getRestrictionsView(Const.SalesOrder);
    const filters = ViewController.filters([...this.list.filters], this.view.filters, mainFilters, this.Restrict);
    this.setState({ ...this.state, inApiCall: true });
    SalesOrderAPI.getList({ ...this.list, filters }, this.onReceived, this.onFail);
  };

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = res => {
    this.data.sales = res.data;
    this.data.count = res.count;
    this.list.pagination.pageCount = Math.ceil(res.count / this.list.pagination.perPage);
    this.setState({ ...this.state, inApiCall: false });
  };

  onPageChange = currentPage => {
    this.list.pagination.currentPage = currentPage;
    this.loadSales();
  };

  onPerPageChange = perPage => {
    this.list.pagination.perPage = perPage;
    this.loadSales();
  };

  onFieldSelection = fields => {
    this.list.fields = fields;
    //reactLocalStorage.setObject(Const.ListSales, this.list);
    this.saveListFields(fields);
  };

  onOrderChange = (field, order) => {
    this.list.sorting = { field, order };
    //reactLocalStorage.setObject(Const.ListSales, this.list);
    this.saveListSort(this.list.sorting);
    this.loadSales();
  };

  toggleFilter = () => {
    this.list.isFilterOpen = !this.state.isFilterOpen;
    reactLocalStorage.setObject(Const.ListSales, this.list);
    this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen });
  };
  closeFilter = () => this.setState({ ...this.state, isFilterOpen: false });
  onFilterChange = filters => { this.list.filters = filters; this.loadSales(); };

  onAddEdit = index => {
    const type = this.data.sales[index].model_no;
    const model = this.data.sales[index].model_id;
    const id = this.data.sales[index].id;
    this.props.navigate(`/sales-order/add-edit/${type}/${model}/${id}`);
  };
  onPreview = index => {
    this.props.navigate(`/sales-order/preview/${this.data.sales[index].id}`);
  };
  onDelete = index => Util.confirmAlert('Delete', 'Are you sure you want to delete',
    'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      SalesOrderAPI.delete(this.data.sales[index].id, this.onDeleteSuccess, this.onFail);
    });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Call deleted successfully', 'success');
    this.loadSales();
  };

  hidePopUp = () => this.setState({ ...this.state, popup: false });

  export = fields => Util.confirmAlert('Export', `Are you sure you want to export to with `
    + ` applied filters ? `, 'Export', 'Cancel', () => {
      this.setState({ ...this.state, inApiCall: true });
      ImportExportAPI.exportModel(Const.SalesOrder, this.list.filters, this.data.count,
        fields, this.model.model_no, this.onExport, this.onFail);
    });
  onExport = () => {
    this.setState({ ...this.state, inApiCall: false });
    Util.showNotification('Successful', 'Sales Order Exported in progress.'
      + ' Please visit Settings', 'success');
  };

  onTabClick = (view) => {
    this.setState({ ...this.state, isFilterOpen: false, inApiCall: true });
    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    cView.sales_order = view;
    reactLocalStorage.setObject(Const.CurrentViews, cView);
    this.view = this.views.find((item) => item.id === view);
    this.setList();
    this.loadSales();
  };

  render() {
    if (!this.List) return null;
    return (
      <div>

        <HeaderViewList views={this.views} view={this.view} onTabClick={this.onTabClick} />

        <ListHeader name={this.model.label_name} pagination={this.list.pagination} model={this.model}
          listCount={this.data.count} filterCount={this.list.filters.length}
          onPageChange={this.onPageChange} perPage={this.list.pagination.perPage}
          onPerPageChange={this.onPerPageChange} toggleFilter={this.toggleFilter}
          onAddClick={() => this.onAddEdit(0)} add={false} export={this.export} />

        <div className="container-fluid ">
          <div className="row">
            <TableUI
              data={this.data.sales}
              model={this.model}
              fields={this.list.fields}
              order={this.list.sorting}
              pagination={this.list.pagination}
              inApiCall={this.state.inApiCall}
              onFieldChange={this.onFieldChange}
              preview={true}
              update={this.Update}
              delete={this.Delete}
              onAddEdit={this.onAddEdit}
              onPreview={this.onPreview}
              onDelete={this.onDelete}
              isFilterOpen={this.state.isFilterOpen}
              onFieldSelection={this.onFieldSelection}
              onOrderChange={this.onOrderChange} />

            <FilterPannel filters={this.list.filters} fields={this.model.fields}
              onFilterChange={this.onFilterChange} isFilterOpen={this.state.isFilterOpen}
              restrict={this.Restrict}
              closeFilter={this.closeFilter} />
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(SalesOrderList);